import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import type { ImportedTableBlockAttsInterface } from '~/types/AppData/Blocks/ImportedTableInterface';
import { getCSSColorChildLinks } from '~/utilities/getCSS';

const cssClasses = cva(
  `w-full [&>table]:w-full [&>table]:border [&>table]:border-solid [&>table]:border-grey 
  [&_th]:border-b [&_th]:border-b-solid [&_th]:border-r [&_th]:border-r-solid [&_th]:p-4 
  [&_tr:nth-child(even)]:bg-lightGrey [&_td]:border-r [&_td]:border-r-solid [&_td]:py-1 [&_td]:px-4 [&_td]:text-center`,
  {
    variants: {
      color: getCSSColorChildLinks(),
    },
  }
);

export default component$(
  ({ html }: ImportedTableBlockAttsInterface): JSX.Element => {
    if (!html) return <></>;
    const {
      themeComponents: { articleBlock },
    } = useContext(AppDataContext);

    return (
      <div class='box-border break-words overflow-auto max-w-[90vw] font-group-normal font-normal scroll-mt-4 md:scroll-mt-24'>
        <div
          dangerouslySetInnerHTML={html}
          class={cssClasses({
            color: articleBlock.paragraphLinkColor.value,
          })}
        />
      </div>
    );
  }
);
